// ========= START: src/components/PronunciationMainMenu.js (Complete File REPLACEMENT) =========
import React, { useState } from 'react';

function PronunciationMainMenu({ user, onStart, onCharacter, onSettings }) {
  // CORRECTED: Implemented the new leveling formula here
  const xpToNextLevel = 1000 + (user.level || 1) * 500;
  const xpProgressPercent = user.xp ? (user.xp / xpToNextLevel) * 100 : 0;
  const [hoveredButton, setHoveredButton] = useState(null);

  return (
    <div className="pronunciation-main-menu">
      <div className="pronunciation-title-container">
        <img
          src={`${process.env.PUBLIC_URL}/assets/logo/bp_shout_logo.png`}
          alt="Pronunciation Challenge Title"
          className="pronunciation-title-image"
        />
      </div>

      <div className="player-info-container">
        <h2 className="player-username-text">{user.username || 'Player'}</h2>
        <h3 className="player-level-text">Level: {user.level}</h3>
        <div className="xp-bar-background">
          <div className="xp-bar-fill" style={{ width: `${xpProgressPercent}%` }} />
        </div>
        <p className="xp-text">{user.xp} / {xpToNextLevel} XP</p>
      </div>
      
      <div className="pronunciation-menu-buttons">
        <button
          className="menu-button-image-pronunciation"
          onClick={onStart}
          onMouseEnter={() => setHoveredButton('start')}
          onMouseLeave={() => setHoveredButton(null)}
        >
          <img
            src={hoveredButton === 'start' ? `${process.env.PUBLIC_URL}/assets/menu-buttons/button_start_hover.gif` : `${process.env.PUBLIC_URL}/assets/menu-buttons/button_start.png`}
            alt="Start Game"
            className="menu-button-image"
          />
        </button>
        <button
          className="menu-button-image-pronunciation"
          onClick={onCharacter}
          onMouseEnter={() => setHoveredButton('character')}
          onMouseLeave={() => setHoveredButton(null)}
        >
          <img
            src={hoveredButton === 'character' ? `${process.env.PUBLIC_URL}/assets/menu-buttons/button_character_hover.gif` : `${process.env.PUBLIC_URL}/assets/menu-buttons/button_character.png`}
            alt="Customize Character"
            className="menu-button-image"
          />
        </button>
        <button
          className="menu-button-image-pronunciation"
          onClick={onSettings}
          onMouseEnter={() => setHoveredButton('settings')}
          onMouseLeave={() => setHoveredButton(null)}
        >
          <img
            src={hoveredButton === 'settings' ? `${process.env.PUBLIC_URL}/assets/menu-buttons/button_settings_hover.gif` : `${process.env.PUBLIC_URL}/assets/menu-buttons/button_settings.png`}
            alt="Settings"
            className="menu-button-image"
          />
        </button>
      </div>
    </div>
  );
}

export default PronunciationMainMenu;
// ========= END: src/components/PronunciationMainMenu.js (Complete File REPLACEMENT) =========